export default "__VITE_ASSET__CuSnot1Z__"